import { ValidationRuleFunction } from 'vee-validate/dist/types/types';

const optional_date: ValidationRuleFunction = (value = '') => {
  const v = String(value);

  return (
    v.match(/^([12]\d{3})$/) !== null ||
    v.match(/^([12]\d{3}-(0[1-9]|1[0-2]))$/) !== null ||
    v.match(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/) !== null
  );
};

export default optional_date;
